/**
 * 商户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="输入商户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.status" clearable placeholder="请选择商户状态">
          <el-option v-for="type in mchStatusEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <!-- 名称、地址内容多，给弹性宽度并允许换行；状态、时间、电话这类短内容给固定窄宽 -->
      <el-table-column sortable prop="mchName" label="商户名称" min-width="160">
      </el-table-column>
      <el-table-column sortable prop="mchAddr" label="商户地址" min-width="320">
      </el-table-column>
      <el-table-column sortable prop="userName" label="联系人" width="110">
      </el-table-column>
      <el-table-column sortable prop="userPhone" label="联系电话" width="130">
      </el-table-column>
      <el-table-column sortable prop="roleStatus" label="商户状态" align="center" width="100">
        <template slot-scope="scope">
          <el-switch active-color="#13ce66" inactive-color="#ff4949" :active-value="1"  :inactive-value="0" v-model="scope.row.mchStatus" @change="mchStatusChange(scope.$index, scope.row)" ></el-switch>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createTime" label="创建时间" align="center" width="120">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.createTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :inline="false" :model="editForm" :rules="rules" ref="editForm">
        <el-descriptions title="商户信息"></el-descriptions>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="商户名称" prop="mchName">
              <el-input size="small" v-model="editForm.mchName" auto-complete="off" placeholder="请输入商户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="商户地址" prop="mchAddr">
              <el-input size="small" v-model="editForm.mchAddr" auto-complete="off" placeholder="请输入商户地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-descriptions title="用户信息"></el-descriptions>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">

            <el-form-item label="联系人" prop="userName">
              <el-input size="small" v-model="editForm.userName" auto-complete="off" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="联系人手机号" prop="userPhone">
              <el-input size="small" v-model="editForm.userPhone" auto-complete="off" placeholder="请输入联系人手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="登录账号" prop="loginName">
              <el-input size="small" v-model="editForm.loginName" auto-complete="off" placeholder="请输入登录账号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="登录密码" prop="loginPassWord">
              <el-input size="small" value="12345678" auto-complete="off" disabled ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mchList, mchSave, deptDelete, changeMchStatus} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      formInline: {
        current: 1,
        size: 10,
        name: '',
        status: null,
        token: localStorage.getItem('logintoken')
      },
      editForm: {
        mchId: null,
        mchName: '',
        mchAddr: '',
        userName:'',
        userPhone:'',
        loginName:'',
        loginPassWord:'',
        mchStatus:null,
        token: localStorage.getItem('logintoken')
      },
      editStatusForm:{
        mchId: '',
        mchStatus: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        mchName: [{ required: true, message: '请输入商户名名称', trigger: 'blur' }],
        mchAddr: [{ required: true, message: '请输入商户地址代码', trigger: 'blur' }]
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        current: 1,
        size: 10,
        total: 10
      },
      mchStatusEnum:[
        { key: '启用', value: 1},
        { key: '禁用', value: 0},
      ],
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表

    getdata: function (parameter) {
      this.loading=true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      mchList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = res.data.pages
            this.pageparm.total = res.data.total
            this.loading=false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = ''
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = ''
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.loading=true
      this.$refs[editData].validate(valid => {
        if (valid) {
          mchSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code==='200') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '商户保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
                this.loading=false
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading=true
          deptDelete(row.mchId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
                this.loading=false
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
                this.loading=false
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    formatDate(timestamp){
      if(timestamp===null){
        return '';
      }
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    mchStatusChange(index, row){
      this.editStatusForm.mchId=row.mchId
      this.editStatusForm.mchStatus=row.mchStatus;
      this.loading=true
      changeMchStatus(this.editStatusForm).then(res => {
          if (res.code==='200') {
            this.$message({
              type: 'success',
              message: '状态已修改！'
            })
            this.getdata(this.formInline)
            this.loading=false
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
            this.loading=false
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('修改状态失败，请稍后再试！')
          this.getdata(this.formInline)
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/mch/Merchant.vue